import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { confirmerContactSurete } from "../../api/contactSurete";

/**
 * Page publique (pas d'authentification) : le contact de sûreté n'a jamais de compte Agbaza —
 * il confirme son rôle en ouvrant simplement le lien reçu par email.
 */
export default function ConfirmerContactSurete() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");
  const [contactNom, setContactNom] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Lien de confirmation invalide : jeton manquant.");
      return;
    }
    let mounted = true;
    confirmerContactSurete(token).then((res) => {
      if (!mounted) return;
      if (res.ok) {
        setContactNom(res.data.nom);
        setStatus("success");
      } else {
        setStatus("error");
        setMessage(res.message);
      }
    });
    return () => {
      mounted = false;
    };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFBFB] p-6">
      <div className="w-full max-w-md rounded-[12px] border bg-white p-6 text-center shadow-sm" style={{ borderColor: "#E5E7EB" }}>
        <img src="/agb.png" alt="AGBAZA" className="mx-auto mb-4 h-9 w-auto" />
        {status === "loading" && <p className="text-sm text-gray-600">Confirmation en cours…</p>}
        {status === "success" && (
          <>
            <h1 className="text-lg font-bold text-[#0B1F16] mb-2">Rôle confirmé</h1>
            <p className="text-sm text-gray-600">
              Merci {contactNom || ""}, votre rôle de contact de sûreté est désormais actif. Vous pourrez être
              sollicité(e) pour autoriser un accès au dossier médical du patient qui vous a désigné, s'il est
              injoignable.
            </p>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="text-lg font-bold text-[#0B1F16] mb-2">Confirmation impossible</h1>
            <p className="text-sm text-red-600">{message}</p>
          </>
        )}
      </div>
    </div>
  );
}
